import React, { createContext } from 'react'

import { navHeight } from './Navbar/styled'

export type LayoutContextType = {
  // Takes into account the navbar and navbar banner.
  navbarOffsetPx: string
}

export const LayoutContext = createContext<LayoutContextType>({
  navbarOffsetPx: navHeight,
})

export default function useLayoutContext(): LayoutContextType {
  return React.useContext(LayoutContext)
}
